/**
 * 매수·매도(호가) API 호출 모듈.
 * axios 인스턴스(src/api/index.js)를 공통으로 사용하며,
 * 인증 토큰은 index.js 인터셉터에서 자동으로 Authorization 헤더에 주입된다.
 *
 * 에러 처리: axios 인터셉터에서 401 시 자동 토큰 갱신, 나머지는 호출부에서 처리.
 */
import api from './index'

/* ================================================================
 * 매수·매도(호가) API
 * ================================================================ */

/**
 * 매수·매도(호가) 목록 조회 (페이지네이션 + 검색 필터).
 * HQ 관리자는 전체, 지점 관리자는 자기 지점 관련 호가만 반환된다.
 *
 * @param {Object} params - { keyword, tradeSide, spotType, startDate, endDate, page, size }
 * @returns {Promise} { code, message, data: { items, total, page, size, totalPages } }
 */
export function getTradeList(params) {
  return api.get('/api/v1/trade', { params })
}

/**
 * 매수·매도(호가) 상세 조회.
 * 호가 정보 + 회원 정보 + 수수료 정산(추천지점/이용지점) 정보를 반환한다.
 *
 * @param {string} p2pAskCode - 호가코드
 * @returns {Promise} { code, message, data: { ...호가정보, ...회원정보, feeSettlements } }
 */
export function getTradeDetail(p2pAskCode) {
  return api.get(`/api/v1/trade/${p2pAskCode}`)
}
